

<template>
    <el-dialog slot="default" center :title="title" :close-on-click-modal="false" @close="onClose"
            :close-on-press-escape="false" :visible="visible">
        <slot></slot>
        <div slot="footer" class="dialog-footer">
            <slot name="footer">
            </slot>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">

export default {
    components: {},
    props: {
        title: {
            type: String,
            default: '标题'
        },
        visible: {
            type: Boolean,
            required: true
        },
        closeButton: {
            type: String,
            default: '取消'
        }
    },
    data() {
        return {
        }
    },
    methods: {
        onClose() {
            this.$emit('update:visible', false);
        },
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    }
}
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Dialog.vue